import { init } from "@ifgengineering/client-analytics";
import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import {
  APP_NAME,
  GOOGLE_ADS_ID,
  GOOGLE_ADS_SIGNUP_TAG_ID,
  MIXPANEL_TOKEN,
  CUSTOMER_IO_WRITE_KEY,
} from "gatsby-env-variables";
import { SENSITIVE_SELECTOR } from "./replayPrivacy";

// COB-3596: Mixpanel EU data residency is now configured in @ifgengineering/client-analytics
const noopAnalytics = () => async () => undefined;

const getAnalytics = () => {
  if (typeof window === "undefined") {
    return noopAnalytics;
  }

  if (window.DO_NOT_TRACK === true) {
    return noopAnalytics;
  }

  const customerIo = AnalyticsBrowser.load({
    writeKey: CUSTOMER_IO_WRITE_KEY,
    cdnURL: "https://cdp-eu.customer.io",
  });

  return init({
    APP_NAME,
    GOOGLE_ADS_ID,
    GOOGLE_ADS_SIGNUP_TAG_ID,
    MIXPANEL_TOKEN,
    customerIO: {
      track: customerIo.track,
      identify: customerIo.identify,
    },
    mixpanelInitOptions: {
      record_sessions_percent: 3,
      // Unmasked for usable triage; mark sensitive elements data-sensitive.
      record_mask_all_text: false,
      record_mask_all_inputs: false,
      record_mask_text_selector: SENSITIVE_SELECTOR,
      record_mask_input_selector: SENSITIVE_SELECTOR,
    },
  });
};

const useAnalytics = getAnalytics();

export default useAnalytics;
